































































































































































































































































import Vue from 'vue';
import SaveData from '@/classes/saveData/saveData';
import Const from '@/classes/const';

export default Vue.extend({
  name: 'SaveItem',
  components: {},
  props: {
    value: {
      type: SaveData,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    handleDelete: {
      type: Function,
      required: true,
    },
    parentDirectory: {
      type: SaveData,
      required: true,
    },
  },
  data: () => ({
    editDialog: false,
    deleteConfirmDialog: false,
    sortConfirmDialog: false,
    editedName: '',
    editedRemarks: '',
    selectedColor: '',
    lastModified: '',
    colors: Const.FILE_COLORS,
    showMenu: false,
    menuX: 0,
    menuY: 0,
  }),
  computed: {
    isNameEmpty(): boolean {
      return this.editedName.length <= 0;
    },
    isNamedEmpty() {
      return this.editedName.length === 0;
    },
  },
  updated() {
    if (this.value.highlight) {
      // 光り終わったら消す通知
      setTimeout(() => {
        const saveData = this.$store.state.saveData as SaveData;
        saveData.clearHighlight();
        this.$store.dispatch('updateSaveData', saveData);
      }, 1600);
    }
  },
  watch: {
    editDialog(value) {
      if (value) {
        setTimeout(() => {
          (this.$refs.nameInput as HTMLInputElement).focus();
        }, 150);
      }
    },
  },
  methods: {
    handleUpdateSaveData(): void {
      // セーブデータの更新を通知
      const saveData = this.$store.state.saveData as SaveData;
      saveData.sortChild();
      this.$store.dispatch('updateSaveData', saveData);
    },
    textFieldFocused(focusEvent: FocusEvent) {
      if (focusEvent) (focusEvent.target as HTMLInputElement).select();
    },
    itemClicked(): void {
      const data = this.value;
      data.selected = true;
      if (!data.isDirectory) {
        if (data.isActive && data.isMain) {
          // 何度もやらせない
          return;
        }
        // ルートのセーブデータを取得し、いったん全てのメイン状態を解除
        const saveData = this.$store.state.saveData as SaveData;
        saveData.disabledMain();

        // クリックされたこれをメイン状態とする
        data.isActive = true;
        data.isMain = true;
        this.$store.dispatch('setMainSaveData', data);

        this.handleUpdateSaveData();
        if (!this.$route.path.endsWith('/aircalc')) {
          // ページ遷移
          this.$router.push('aircalc');
        }
        return;
      }
      data.isOpen = !data.isOpen;
    },
    copyAndOpen() {
      const data = this.value;
      if (!data.isDirectory) {
        // ルートのセーブデータを取得し、いったん全てのメイン状態を解除
        const saveData = this.$store.state.saveData as SaveData;
        saveData.disabledMain();

        // クリックされたこれを複製
        const newData = new SaveData();
        newData.name = `${data.name}_コピー`;
        newData.manager = data.manager;
        newData.remarks = data.remarks;
        newData.isActive = true;
        newData.isMain = true;

        saveData.childItems.push(newData);
        this.$store.dispatch('setMainSaveData', newData);

        this.handleUpdateSaveData();
        if (!this.$route.path.endsWith('/aircalc')) {
          // ページ遷移
          this.$router.push('aircalc');
        }
        return;
      }
      data.isOpen = !data.isOpen;
    },
    onClickOutside(): void {
      this.value.selected = false;
    },
    deleteData() {
      this.deleteConfirmDialog = false;
      if (!this.value.isReadonly) {
        this.handleDelete(this.index);
      }
    },
    deleteChild(index: number) {
      // データの削除は常にこのメソッドにより行われる
      this.value.childItems = this.value.childItems.filter((v, i) => i !== index);
      // 更新を通知
      this.handleUpdateSaveData();

      // メイン計算データの削除がされていないかチェック されていたら更新通知 => 計算画面だったらトップページに戻ってくれる
      const saveData = this.$store.state.saveData as SaveData;
      if (!saveData.getMainData()) {
        this.$store.dispatch('setMainSaveData', undefined);
      }
    },
    showEditDialog() {
      this.editedName = this.value.name;
      this.editedRemarks = this.value.remarks ? this.value.remarks : '';
      this.selectedColor = this.value.color;
      this.lastModified = new Date(this.value.editedDate).toLocaleString(this.$vuetify.lang.current);
      this.editDialog = true;
    },
    commitName() {
      if (this.isNameEmpty) {
        return;
      }
      this.editDialog = false;
      this.value.name = this.editedName.trim();
      this.value.remarks = this.editedRemarks ? this.editedRemarks.trim() : '';
      this.value.editedDate = Date.now();
      this.value.color = this.selectedColor;
      this.handleUpdateSaveData();
    },
    autoSortDirectory() {
      this.value.nameSortChild();
      this.handleUpdateSaveData();
      this.sortConfirmDialog = false;
    },
    dragStart(e: DragEvent) {
      const target = e.target as HTMLDivElement;
      target.style.opacity = '0.6';
      target.id = 'dragging-item';

      // ドラッグ中セーブデータを一時保持
      this.$store.dispatch('setDraggingSaveData', this.value);

      const itemList = document.getElementsByClassName('save-list');
      for (let i = 0; i < itemList.length; i += 1) {
        itemList[i].classList.add('dragging');
      }
    },
    dragLeave(e: DragEvent) {
      const target = e.target as HTMLDivElement;
      target.classList.remove('on-item-before', 'on-item-after', 'on-item-directory');
    },
    dragOver(e: DragEvent) {
      const draggingDiv = document.getElementById('dragging-item');
      const target = e.target as HTMLDivElement;
      if (!draggingDiv || !target || target === draggingDiv) {
        target.classList.remove('on-item-before', 'on-item-after', 'on-item-directory');
        return;
      }
      // 乗っている要素に対するマウスのy座標
      const mouseY = e.clientY - target.getBoundingClientRect().top;
      if (this.value.isDirectory) {
        // 並べ替え上下の境界
        const beforeBorder = 5;
        const afterBorder = 23;

        if (!this.value.isReadonly && mouseY <= beforeBorder) {
          target.classList.add('on-item-before');
          target.classList.remove('on-item-after', 'on-item-directory');
        } else if (mouseY <= afterBorder) {
          // 中間地点 フォルダ内に突っ込む判定
          target.classList.add('on-item-directory');
          target.classList.remove('on-item-after', 'on-item-before');
        } else if (!this.value.isOpen) {
          target.classList.add('on-item-after');
          target.classList.remove('on-item-before', 'on-item-directory');
        }
      } else if (!this.value.isUnsaved) {
        // 並べ替え上下の境界
        const border = target.offsetHeight / 2;
        if (mouseY <= border) {
          target.classList.add('on-item-before');
          target.classList.remove('on-item-after');
        } else {
          target.classList.add('on-item-after');
          target.classList.remove('on-item-before');
        }
      }
      e.preventDefault();
    },
    dropItem(e: DragEvent) {
      // 受け渡されたデータ
      const draggingDiv = document.getElementById('dragging-item');
      // そもそもドラッグ開始が正常になされているか
      if (!draggingDiv) {
        return;
      }

      // ドロップされる要素
      const target = e.target as HTMLDivElement;
      if (target.id || this.value.isUnsaved) {
        // 自身へのドロップ禁止 未保存データへのドラッグ禁止
        target.classList.remove('on-item-before', 'on-item-after', 'on-item-directory');
        return;
      }

      // 一時退避していたデータを取得
      const moveData = this.$store.state.draggingSaveData as SaveData;

      // 動かそうとしているデータがディレクトリだった場合、自身の子要素へのドロップは再帰処理で死ぬのでキャンセルする
      if (moveData.isDirectory) {
        // 上のmoveData(動かそうとしているディレクトリ内)に入っている子要素のidをすべて列挙
        const childIds = moveData.getAllDataId();
        if (childIds.includes(this.value.id)) {
          // この子(ドロップ先)要素が、ディレクトリ内の子要素であったらキャンセル
          target.classList.remove('on-item-before', 'on-item-after', 'on-item-directory');
          return;
        }
      }

      if (this.value.isDirectory && target.classList.contains('on-item-directory')) {
        // ディレクトリで、ディレクトリ内に突っ込む判定だった場合
        moveData.order = 999999;
        this.value.childItems.push(moveData);
      } else if (this.parentDirectory.isDirectory && target.classList.contains('on-item-before')) {
        // 対象の直前に挿入
        moveData.order = this.value.order - 1;
        this.parentDirectory.childItems.push(moveData);
      } else if (this.parentDirectory.isDirectory && target.classList.contains('on-item-after')) {
        // 対象の直後に挿入
        moveData.order = this.value.order + 1;
        this.parentDirectory.childItems.push(moveData);
      } else {
        // 謎の判定 ここで返さないとデータが消えるので返す
        target.classList.remove('on-item-before', 'on-item-after', 'on-item-directory');
        return;
      }

      draggingDiv.classList.add('move-ok');
      target.classList.remove('on-item-before', 'on-item-after', 'on-item-directory');
    },
    dragEnd(e: DragEvent) {
      const target = e.target as HTMLDivElement;
      target.style.opacity = '1';

      target.id = '';
      if (target.classList.contains('move-ok')) {
        this.deleteData();
        target.classList.remove('move-ok');
      }

      const itemList = document.getElementsByClassName('save-list');
      for (let i = 0; i < itemList.length; i += 1) {
        itemList[i].classList.remove('dragging');
      }
    },
    showSaveDataMenu(e: MouseEvent) {
      e.preventDefault();
      this.showMenu = false;
      this.menuX = e.clientX;
      this.menuY = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    keydownHandler(event: KeyboardEvent) {
      if (event.ctrlKey && event.code === 'KeyS') {
        event.preventDefault();
        event.stopPropagation();
        this.commitName();
      }
    },
  },
});
